/* eslint-disable no-unused-vars */
import React, { useCallback, useState } from 'react';
import { ONE_DAY } from 'utils/constants';
import UserProvider from 'contexts/UserContext';
import { STATION_ID_DEFAULT, STATION_NAME_DEFAULT } from 'settings';
import { Container } from './styles';
import EntryScreen from './EntryScreen';

const EntryPointDefault = {
  systemId: 'sun',
  objId: STATION_ID_DEFAULT,
  name: STATION_NAME_DEFAULT,
};

const launchGame = (mode) => {
  const StartCookie = {
    stationId: EntryPointDefault.objId,
    stationName: EntryPointDefault.name,
    mode,
    demoScript: mode === 'demo' ? 'default' : undefined,
  };
  const expires = new Date(Date.now() + ONE_DAY);
  const host = window.location.hostname;
  const onMilkway = host === 'milkway.link' || host.endsWith('.milkway.link');
  const domainPart = onMilkway ? '; domain=milkway.link' : '';

  document.cookie = `MilkwayStartCookie=${encodeURIComponent(JSON.stringify(StartCookie))}${domainPart}; path=/; expires=${expires.toUTCString()}`;

  try {
    sessionStorage.removeItem('MilkwayDemoState');
  } catch (e) { /* ignore */ }

  const gameBase = process.env.REACT_APP_GAME_URL || '/';
  const gameUrl = new URL(gameBase, window.location.href);
  window.location.replace(gameUrl.toString());
};

const App = () => {
  const [launching, setLaunching] = useState(false);

  const handleChoose = useCallback((mode) => {
    setLaunching(true);
    launchGame(mode);
  }, []);

  return (
    <UserProvider>
      <Container style={{ padding: 0, overflow: 'hidden' }}>
        {launching ? (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            color: '#ccc',
            fontFamily: 'Verdana, Geneva, Tahoma, sans-serif',
          }}
          >
            Entering Milkway…
          </div>
        ) : (
          <EntryScreen onChoose={handleChoose} />
        )}
      </Container>
    </UserProvider>
  );
};

export default App;
